<template>
  <div>
    <v-form v-model="valid">
      <v-dialog
          v-model="localOpen"
          @click:outside="disableOverlayClick===undefined ? localOpen=false : null"
          :max-width="fullscreen!==undefined ? null : width===undefined ? 425 : width"
          scrollable
          :fullscreen="fullscreen!==undefined"
          :persistent="disableOverlayClick!==undefined"
      >
        <v-card>
          <v-sheet :color="color!==undefined ? color : 'grey lighten-5'">
            <v-toolbar dense elevation="0" color="transparent" max-height="48px">
              <v-toolbar-title :style="color!==undefined && `color:${$tools.getContrastColor(color)}`">{{typeof name==='undefined' ? '' : ' '+name}} {{this.localItem===null || typeof this.localItem.id==='undefined' || this.localItem.id===null ? '' : '#'+this.localItem.id}}</v-toolbar-title>

              <slot name="afterTitle" v-bind:localItem="localItem"/>
              
              <v-spacer/>
              <slot name="actions" v-bind:localItem="localItem"/>
              <v-btn v-if="closeConfirm===undefined" icon @click="localOpen=false" :disabled="loading" :color="color!==undefined ? $tools.getContrastColor(color) : null">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <btn-icon-accept v-else :disabled="loading" @accept="localOpen=false" icon="mdi-close" :color="color!==undefined ? $tools.getContrastColor(color) : null" text="Вы уверены, что хотите закрыть?"/>
            </v-toolbar>
            <slot v-if="localItem!==null" name="header" v-bind:localItem="localItem"/>
          </v-sheet>
          <v-divider/>
          <div :class="'overflow-y-auto'+(typeof contentPaddingRemove==='undefined' ? ' pt-4 px-4' : '')">
            <v-sheet :height="typeof fixedHeight==='undefined' ? null : $tools.pageHeight()-220" class="full-width position-relative">
              <slot v-if="localItem!==null" v-bind:localItem="localItem" v-bind:height="typeof fixedHeight==='undefined' ? null : $tools.pageHeight()-220"/>
            </v-sheet>
          </div>
          <v-divider v-if="typeof footerHide==='undefined' || footerHide===true"/>
          <v-row v-if="typeof footerHide==='undefined' || footerHide===true" no-gutters class="mx-4 my-2 text-right">
            <v-col cols="auto">
              <slot name="footerActions" v-if="localItem!==null" v-bind:localItem="localItem"/>
            </v-col>
            <v-col>
              <v-sheet height="36">
                <v-btn
                    v-if="typeof submitText==='undefined' || submitText!==null"
                    @click="localLoading=true;$tools.debounce(()=>{localLoading=false},1000);$emit('submit',localItem)"
                    :disabled="!valid || loading"
                    :loading="loading || localLoading"
                    color="primary" text type="submit"
                >
                  {{typeof submitText==='undefined' ? 'OK' : submitText}}
                </v-btn>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import BtnIconAccept from "@/componentsV2/base/BtnIconAccept.vue";

export default {
  props:[
    'name',
    'item',
    'width',
    'fullscreen',
    'fixedHeight',
    'contentPaddingRemove',
    'loading',
    'footerHide',
    'submitText',
    'disableOverlayClick',
    'color',
    'closeConfirm'
  ],
  components:{
    BtnIconAccept
  },
  data:()=>({
    localItem:null,
    localOpen:false,
    localLoading:false,
    valid:true,
  }),
  watch:{
    item(){
      if(this.item===null) {
        this.localOpen = false;
        setTimeout(()=>{
          this.localItem = null;
        },200)
      } else {
        this.localItem = this.$tools.copy(this.item);
        this.localOpen = true;
        this.localLoading = false;
      }
    },
    localOpen(){
      if(!this.localOpen)
        this.$emit('update:item', null);
    },
    loading(){
      this.localLoading = this.loading;
    }
  }
}
</script>